export default {
  log_activity: 'Registrer denne aktiviteten:',
  learn_more: 'Lær mer om denne aktiviteten:',
};
